<template>
    <body>
        <main app="">
            <div class="layout row wrap mb-3">
                <div class="flex xs12">
                    <div class="card" style="height: auto">
                        <div class="container fluid">
                            <div class="layout">
                                <div class="flex pa-3">
                                    <h1>Miners</h1>
                                    <p>
                                        Click on a miner to learn more about it,
                                        see the paintings it appears in, and the
                                        blocks it mined.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex text-xs-center xs12">
                    <div class="card" style="height: auto">
                        <div class="layout row wrap">
                            <div class="flex text-xs-center xs12">
                                <div class="card" style="height: auto">
                                    <div class="container fluid">
                                        <div class="layout">
                                            <div class="flex pt-2">
                                                <h1>In chronological order</h1>
                                                <p>(oldest to newest)</p>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex text-xs-center xs12">
                                <div class="card" style="height: auto">
                                    <div class="container fluid grid-list-md">
                                        <div
                                            class="layout row justify-center align-center mt-2 mb-2"
                                        >
                                            <button
                                                disabled="disabled"
                                                type="button"
                                                class="btn btn--disabled btn--floating btn--small theme--dark cyanBlue lighten-1"
                                            >
                                                <div class="btn__content">
                                                    <i
                                                        aria-hidden="true"
                                                        class="icon theme--dark fas fa-angle-double-left"
                                                    ></i>
                                                </div>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                mt-4=""
                                            >
                                                <div class="btn__content">
                                                    <i
                                                        aria-hidden="true"
                                                        class="icon theme--dark fas fa-angle-right material-icons"
                                                        style="display: flex"
                                                        >keyboard_arrow_right</i
                                                    >
                                                </div>
                                            </button>
                                            <div
                                                align-center=""
                                                class="card__title"
                                            >
                                                <h1>1 - 9</h1>
                                            </div>
                                            <button
                                                type="button"
                                                class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                mt-4=""
                                            >
                                                <div class="btn__content">
                                                    <i
                                                        aria-hidden="true"
                                                        class="icon theme--dark fas fa-angle-right material-icons"
                                                        style="display: flex"
                                                        >keyboard_arrow_right</i
                                                    >
                                                </div>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                mt-4=""
                                            >
                                                <div class="btn__content">
                                                    <i
                                                        aria-hidden="true"
                                                        class="icon theme--dark fas fa-angle-right material-icons"
                                                        style="display: flex"
                                                        >keyboard_double_arrow_right</i
                                                    >
                                                </div>
                                            </button>
                                        </div>
                                        <div class="layout row wrap">
                                            <div
                                                class="flex xs12 sm6 md4 lg4 xl4"
                                            >
                                                <a
                                                    href="/miners/0x0000000000000000000000000000000000000000"
                                                    class="ma-2 pa-3 pt-0 card card--hover"
                                                    style="height: auto"
                                                    ><div class="card__text">
                                                        <h5
                                                            class="headline ma-0"
                                                        >
                                                            Miner #1
                                                        </h5>
                                                        <span
                                                            class="grey--text ma-0"
                                                        >
                                                            Seen in 39
                                                            paintings<br />
                                                            Mined 95 blocks
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="card__media"
                                                        style="height: 240px"
                                                    >
                                                        <div
                                                            class="card__media__background"
                                                            style="
                                                                background: url('https://storage.googleapis.com/pcarte/miners/0x0000000000000000000000000000000000000000.png')
                                                                    center
                                                                    center /
                                                                    contain
                                                                    no-repeat;
                                                            "
                                                        ></div>
                                                        <div
                                                            class="card__media__content"
                                                        ></div></div
                                                ></a>
                                            </div>
                                            <div
                                                class="flex xs12 sm6 md4 lg4 xl4"
                                            >
                                                <a
                                                    href="/miners/0x05a56e2d52c817161883f50c441c3228cfe54d9f"
                                                    class="ma-2 pa-3 pt-0 card card--hover"
                                                    style="height: auto"
                                                    ><div class="card__text">
                                                        <h5
                                                            class="headline ma-0"
                                                        >
                                                            Miner #2
                                                        </h5>
                                                        <span
                                                            class="grey--text ma-0"
                                                        >
                                                            Seen in 33
                                                            paintings<br />
                                                            Mined 53 blocks
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="card__media"
                                                        style="height: 240px"
                                                    >
                                                        <div
                                                            class="card__media__background"
                                                            style="
                                                                background: url('https://storage.googleapis.com/pcarte/miners/0x05a56e2d52c817161883f50c441c3228cfe54d9f.png')
                                                                    center
                                                                    center /
                                                                    contain
                                                                    no-repeat;
                                                            "
                                                        ></div>
                                                        <div
                                                            class="card__media__content"
                                                        ></div></div
                                                ></a>
                                            </div>
                                            <div
                                                class="flex xs12 sm6 md4 lg4 xl4"
                                            >
                                                <a
                                                    href="/miners/0xdd2f1e6e498202e86d8f5442af596580a4f03c2c"
                                                    class="ma-2 pa-3 pt-0 card card--hover"
                                                    style="height: auto"
                                                    ><div class="card__text">
                                                        <h5
                                                            class="headline ma-0"
                                                        >
                                                            Miner #3
                                                        </h5>
                                                        <span
                                                            class="grey--text ma-0"
                                                        >
                                                            Seen in 179
                                                            paintings<br />
                                                            Mined 325 blocks
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="card__media"
                                                        style="height: 240px"
                                                    >
                                                        <div
                                                            class="card__media__background"
                                                            style="
                                                                background: url('https://storage.googleapis.com/pcarte/miners/0xdd2f1e6e498202e86d8f5442af596580a4f03c2c.png')
                                                                    center
                                                                    center /
                                                                    contain
                                                                    no-repeat;
                                                            "
                                                        ></div>
                                                        <div
                                                            class="card__media__content"
                                                        ></div></div
                                                ></a>
                                            </div>
                                            <div
                                                class="flex xs12 sm6 md4 lg4 xl4"
                                            >
                                                <a
                                                    href="/miners/0x5088d623ba0fcf0131e0897a91734a4d83596aa0"
                                                    class="ma-2 pa-3 pt-0 card card--hover"
                                                    style="height: auto"
                                                    ><div class="card__text">
                                                        <h5
                                                            class="headline ma-0"
                                                        >
                                                            Miner #4
                                                        </h5>
                                                        <span
                                                            class="grey--text ma-0"
                                                        >
                                                            Seen in 23
                                                            paintings<br />
                                                            Mined 294 blocks
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="card__media"
                                                        style="height: 240px"
                                                    >
                                                        <div
                                                            class="card__media__background"
                                                            style="
                                                                background: url('https://storage.googleapis.com/pcarte/miners/0x5088d623ba0fcf0131e0897a91734a4d83596aa0.png')
                                                                    center
                                                                    center /
                                                                    contain
                                                                    no-repeat;
                                                            "
                                                        ></div>
                                                        <div
                                                            class="card__media__content"
                                                        ></div></div
                                                ></a>
                                            </div>
                                            <div
                                                class="flex xs12 sm6 md4 lg4 xl4"
                                            >
                                                <a
                                                    href="/miners/0xc8ebccc5f5689fa8659d83713341e5ad19349448"
                                                    class="ma-2 pa-3 pt-0 card card--hover"
                                                    style="height: auto"
                                                    ><div class="card__text">
                                                        <h5
                                                            class="headline ma-0"
                                                        >
                                                            Miner #5
                                                        </h5>
                                                        <span
                                                            class="grey--text ma-0"
                                                        >
                                                            Seen in 61
                                                            paintings<br />
                                                            Mined 89 blocks
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="card__media"
                                                        style="height: 240px"
                                                    >
                                                        <div
                                                            class="card__media__background"
                                                            style="
                                                                background: url('https://storage.googleapis.com/pcarte/miners/0xc8ebccc5f5689fa8659d83713341e5ad19349448.png')
                                                                    center
                                                                    center /
                                                                    contain
                                                                    no-repeat;
                                                            "
                                                        ></div>
                                                        <div
                                                            class="card__media__content"
                                                        ></div></div
                                                ></a>
                                            </div>
                                            <div
                                                class="flex xs12 sm6 md4 lg4 xl4"
                                            >
                                                <a
                                                    href="/miners/0x0193d941b50d91be6567c7ee1c0fe7af498b4137"
                                                    class="ma-2 pa-3 pt-0 card card--hover"
                                                    style="height: auto"
                                                    ><div class="card__text">
                                                        <h5
                                                            class="headline ma-0"
                                                        >
                                                            Miner #6
                                                        </h5>
                                                        <span
                                                            class="grey--text ma-0"
                                                        >
                                                            Seen in 371
                                                            paintings<br />
                                                            Mined 1,001 blocks
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="card__media"
                                                        style="height: 240px"
                                                    >
                                                        <div
                                                            class="card__media__background"
                                                            style="
                                                                background: url('https://storage.googleapis.com/pcarte/miners/0x0193d941b50d91be6567c7ee1c0fe7af498b4137.png')
                                                                    center
                                                                    center /
                                                                    contain
                                                                    no-repeat;
                                                            "
                                                        ></div>
                                                        <div
                                                            class="card__media__content"
                                                        ></div></div
                                                ></a>
                                            </div>
                                            <div
                                                class="flex xs12 sm6 md4 lg4 xl4"
                                            >
                                                <a
                                                    href="/miners/0x19dafe19f11e960e4ccfc6a5aa8890ebd748ca1e"
                                                    class="ma-2 pa-3 pt-0 card card--hover"
                                                    style="height: auto"
                                                    ><div class="card__text">
                                                        <h5
                                                            class="headline ma-0"
                                                        >
                                                            Miner #7
                                                        </h5>
                                                        <span
                                                            class="grey--text ma-0"
                                                        >
                                                            Seen in 413
                                                            paintings<br />
                                                            Mined 510 blocks
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="card__media"
                                                        style="height: 240px"
                                                    >
                                                        <div
                                                            class="card__media__background"
                                                            style="
                                                                background: url('https://storage.googleapis.com/pcarte/miners/0x19dafe19f11e960e4ccfc6a5aa8890ebd748ca1e.png')
                                                                    center
                                                                    center /
                                                                    contain
                                                                    no-repeat;
                                                            "
                                                        ></div>
                                                        <div
                                                            class="card__media__content"
                                                        ></div></div
                                                ></a>
                                            </div>
                                            <div
                                                class="flex xs12 sm6 md4 lg4 xl4"
                                            >
                                                <a
                                                    href="/miners/0xd7e30ae310c1d1800f5b641baa7af95b2e1fd98c"
                                                    class="ma-2 pa-3 pt-0 card card--hover"
                                                    style="height: auto"
                                                    ><div class="card__text">
                                                        <h5
                                                            class="headline ma-0"
                                                        >
                                                            Miner #8
                                                        </h5>
                                                        <span
                                                            class="grey--text ma-0"
                                                        >
                                                            Seen in 41
                                                            paintings<br />
                                                            Mined 505 blocks
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="card__media"
                                                        style="height: 240px"
                                                    >
                                                        <div
                                                            class="card__media__background"
                                                            style="
                                                                background: url('https://storage.googleapis.com/pcarte/miners/0xd7e30ae310c1d1800f5b641baa7af95b2e1fd98c.png')
                                                                    center
                                                                    center /
                                                                    contain
                                                                    no-repeat;
                                                            "
                                                        ></div>
                                                        <div
                                                            class="card__media__content"
                                                        ></div></div
                                                ></a>
                                            </div>
                                            <div
                                                class="flex xs12 sm6 md4 lg4 xl4"
                                            >
                                                <a
                                                    href="/miners/0xacc8decdfdcbed202b8632947c60487494f5d2c7"
                                                    class="ma-2 pa-3 pt-0 card card--hover"
                                                    style="height: auto"
                                                    ><div class="card__text">
                                                        <h5
                                                            class="headline ma-0"
                                                        >
                                                            Miner #9
                                                        </h5>
                                                        <span
                                                            class="grey--text ma-0"
                                                        >
                                                            Seen in 31
                                                            paintings<br />
                                                            Mined 42 blocks
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="card__media"
                                                        style="height: 240px"
                                                    >
                                                        <div
                                                            class="card__media__background"
                                                            style="
                                                                background: url('https://storage.googleapis.com/pcarte/miners/0xacc8decdfdcbed202b8632947c60487494f5d2c7.png')
                                                                    center
                                                                    center /
                                                                    contain
                                                                    no-repeat;
                                                            "
                                                        ></div>
                                                        <div
                                                            class="card__media__content"
                                                        ></div></div
                                                ></a>
                                            </div>
                                        </div>
                                        <div
                                            class="layout row justify-center align-center mt-2 mb-2"
                                        >
                                            <button
                                                disabled="disabled"
                                                type="button"
                                                class="btn btn--disabled btn--floating btn--small theme--dark cyanBlue lighten-1"
                                            >
                                                <div class="btn__content">
                                                    <i
                                                        aria-hidden="true"
                                                        class="icon theme--dark fas fa-angle-double-left"
                                                    ></i>
                                                </div>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                mt-4=""
                                            >
                                                <div class="btn__content">
                                                    <i
                                                        aria-hidden="true"
                                                        class="icon theme--dark fas fa-angle-right material-icons"
                                                        style="display: flex"
                                                        >keyboard_arrow_right</i
                                                    >
                                                </div>
                                            </button>
                                            <div
                                                align-center=""
                                                class="card__title"
                                            >
                                                <h1>1 - 9</h1>
                                            </div>
                                            <button
                                                type="button"
                                                class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                mt-4=""
                                            >
                                                <div class="btn__content">
                                                    <i
                                                        aria-hidden="true"
                                                        class="icon theme--dark fas fa-angle-right material-icons"
                                                        style="display: flex"
                                                        >keyboard_arrow_right</i
                                                    >
                                                </div>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn--floating btn--small theme--dark cyanBlue lighten-1"
                                                mt-4=""
                                            >
                                                <div class="btn__content">
                                                    <i
                                                        aria-hidden="true"
                                                        class="icon theme--dark fas fa-angle-right material-icons"
                                                        style="display: flex"
                                                        >keyboard_arrow_right</i
                                                    >
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <!-- <script type="text/javascript" src="/static/js/manifest.5f946d972125a67eabf1.js"></script>
                <script type="text/javascript" src="/static/js/vendor.e47676f654e7bc42a06c.js"></script>
                <script type="text/javascript" src="/static/js/app.020921c3752b3f33b6dd.js"></script>-->
        <iframe
            frameborder="0"
            allowtransparency="true"
            src="https://checkout.stripe.com/v3/JdhudoUwvSFS85kPDZEQ.html?distinct_id=6fc92829-18d9-1742-7119-7e180b6b2dbe"
            name="stripe_checkout_app"
            class="stripe_checkout_app"
            style="
                z-index: 2147483647;
                display: none;
                background: rgba(0, 0, 0, 0.004);
                border: 0px none transparent;
                overflow: hidden auto;
                visibility: visible;
                margin: 0px;
                padding: 0px;
                -webkit-tap-highlight-color: transparent;
                position: fixed;
                left: 0px;
                top: 0px;
                width: 100%;
                height: 100%;
            "
        >
        </iframe>
    </body>
</template>

<script>
/* eslint-disable vue/no-unused-components */
export default {
    name: "Miners",
    data() {
        return {
            info: [
                { id: "0", text: "John" },
                { id: "1", text: "Mary" },
            ],
        };
    },
    methods: {
        isMobile() {
            return true;
            /* return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent);
            */
        },
    },
    mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute(
            "src",
            "https://www.google.com/recaptcha/api.js"
        );
        document.head.appendChild(recaptchaScript);
    },
};
</script>

<style></style>
